import Vue from 'vue'
import Vuex from 'vuex'
import invests from './modules/invests'
import investors from './modules/investors'
import filters from './modules/filters'
import classificators from './modules/classificators'
import localStorageHelper from '../helpers/localStorageHelper'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    email: localStorageHelper.get('email')
  },
  mutations: {
    updateEmail(state, email)
    {
      state.email = email.concat()
      localStorageHelper.set('email', state.email)
    }
  },
  actions: {
    updateEmail({commit}, email)
    {
      commit('updateEmail', email)
    }
  },
  modules: {
    invests, investors, filters, classificators
  },
  getters: {
    email: store => store.email
  }
})
